import React from "react";
import { PhoneInput } from "./styles";
import { DefaultInputComponentProps } from "react-phone-number-input";

const CustomPhoneInput: React.FC<DefaultInputComponentProps> = (props) => {
  return <PhoneInput {...props} />;
};

export default CustomPhoneInput;
